import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../../Styles/Login.css";
import Logo from "../../assets/images/logo.png";
import { useState } from "react";
import { useFormik } from "formik";
import { toast } from "sonner";
import * as Yup from "yup";
import LoadingSpinner from "../../Components/spinner";
import { resetPassword } from "../../services/axios/apiManager";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const isRedirect = searchParams.get("redirect");
  const [loading, setLoading] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  console.log("isRedirect :", typeof isRedirect);

  const passwordSchema = Yup.object().shape({
    newPassword: Yup.string()
      .min(8, "New password must be at least 8 characters long")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const passwordFormik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: passwordSchema,
    onSubmit: async (values) => {
      try {
        if (loading) return;
        if (!token) {
          toast.error("Invalid link or token not present.", { duration: 5000 });
          return;
        }
        setLoading(true);
        const data = {
          password: values.newPassword,
          token: token,
        };
        const res = await resetPassword(data);

        if (res?.data?.success) {
          toast.success(
            res?.data?.message || "Your password has been updated",
            { duration: 5000 }
          );
          if (isRedirect === "true") {
            navigate("/AdminProfile");
          } else {
            navigate("/login");
          }
        } else {
          toast.error(
            res?.data?.message ||
              res?.response?.data?.message ||
              "Password is not updated, Invalid or expired link",
            { duration: 5000 }
          );
        }
      } catch (error) {
        console.log("Error upon password form submition", error);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <main className="nftg-content-two" style={{ backgroundColor: "#0b0f14" }}>
      <section className="authentication pt-120 pb-120 fade-wrapper">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="authentication__wrapper text-center">
                <img src={Logo} style={{ margin: "0 auto", width: "120px" }} />
                <div className="mb-55">
                  <h2
                    className="title-lg fw-8 stroked-text transform-none title-animation"
                    style={{ color: "white", fontWeight: "700" }}
                  >
                    Reset Password
                  </h2>
                  <p
                    className="text-xl text-alter"
                    style={{ color: "gray", fontWeight: "400" }}
                  >
                    Choose a strong password.
                  </p>
                </div>
                <div className="authentication__inner">
                  <div className="custom-tab">
                    <div className="input-single mb-3">
                      <label htmlFor="newPassword">New Password</label>
                      <div className="position-relative">
                        <input
                          type={showNew ? "text" : "password"}
                          className="form-control bg-dark text-light border-light input-placeholder-light"
                          id="newPassword"
                          style={{ height: "50px", paddingRight: "45px" }}
                          placeholder="Enter new password"
                          {...passwordFormik.getFieldProps("newPassword")}
                        />
                        <button
                          type="button"
                          className="btn btn-link position-absolute end-5 top-50 translate-middle-y text-decoration-none text-secondary"
                          onClick={() => setShowNew(!showNew)}
                          style={{ zIndex: 10 }}
                        >
                          <i
                            className={`ri-${showNew ? "eye-off" : "eye"}-fill align-middle`}
                          />
                        </button>
                      </div>
                      {passwordFormik.errors.newPassword &&
                        passwordFormik.touched.newPassword && (
                          <span className="text-danger">
                            {passwordFormik.errors.newPassword}
                          </span>
                        )}
                    </div>
                    {/* ///////////////////////////////////////////////////////// */}
                    <div className="input-single">
                      <label htmlFor="confirmPassword">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          type={showConfirm ? "text" : "password"}
                          className="form-control bg-dark text-light border-light input-placeholder-light"
                          id="confirmPassword"
                          style={{ height: "50px", paddingRight: "45px" }}
                          placeholder="Confirm password"
                          {...passwordFormik.getFieldProps("confirmPassword")}
                        />
                        <button
                          type="button"
                          className="btn btn-link position-absolute end-5 top-50 translate-middle-y text-decoration-none text-secondary"
                          onClick={() => setShowConfirm(!showConfirm)}
                          style={{ zIndex: 10 }}
                        >
                          <i
                            className={`ri-${showNew ? "eye-off-fill" : "eye-fill"}`}
                          />
                        </button>
                      </div>
                      {passwordFormik.errors.confirmPassword &&
                        passwordFormik.touched.confirmPassword && (
                          <span className="text-danger">
                            {passwordFormik.errors.confirmPassword}
                          </span>
                        )}
                    </div>
                    <div className="btn-wrapper">
                      <button
                        className="btn--secondary"
                        data-testid="submit-button"
                        type="button"
                        aria-label="submit"
                        title="submit"
                        onClick={() => {
                          passwordFormik.handleSubmit();
                        }}
                      >
                        {loading ? <LoadingSpinner size="lg" /> : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
